import apiClient from '../../../apis/portaliref';
import sherlock from '../../../apis/sherlock';
import { portaleApi } from '../../../helpers/portaleModuleHelper';

const api = portaleApi('paginaDestinazione', apiClient, {
    per_page: 'perPage',
    page: 'page',
    slug: 'q',
    orderby: 'orderKey',
    orderdir: 'orderDirection',
    portale: 'portale',
    servizio: 'servizio',
    comune: 'comune',
    localita: 'localita',
});

api.create = (data) => {
    return apiClient({
        url: 'paginaDestinazione',
        method: 'POST',
        data,
    });
};

api.editPage = (id, data) => {
    return apiClient({
        url: `paginaDestinazione/${id}`,
        method: 'patch',
        data,
    });
};

api.dupePage = (_idPage, _newSlug) => {
    return apiClient({
        url: `page/dupe/${_idPage}?slug=${_newSlug}`,
        method: 'GET',
        data: {
            slug: _newSlug,
        },
    });
};

api.elencoDestinazioni = () => {
    return apiClient({
        url: 'destinazioni/listaNomi',
        method: 'GET',
    });
};

export default api;

const sherlockApi = sherlock;

sherlockApi.getBalance = () => {
    return sherlock({
        url: 'balance',
        method: 'GET',
    });
};

sherlockApi.getPlagiarisms = (text, excludedSites) => {
    let excluded_sites;

    if (typeof excludedSites !== 'undefined' && excludedSites !== null)
        excluded_sites = excludedSites;

    const data = {
        text,
        excluded_sites,
    };

    return sherlock({
        url: 'plagiarism',
        method: 'POST',
        data,
    });
};

export { sherlockApi };
